(function () {
    function Fetch() {
        const defaults = {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            query: {},
            data: undefined,
            timeout: 30000,
            retry: 0,
            format: "json",
            method: "GET",
            credentials: "same-origin",
            mode: 'cors',
            token: false
        };
        const token = {
            url: "/rest/session/token",
            header: "X-CSRF-Token"
        };
        return function (url, config) {
            config = Object.assign(defaults, config);
            function timeoutHandler(ms, promise) {
                return new Promise(function (resolve, reject) {
                    setTimeout(function () {
                        reject(new Error("Timeout"));
                    }, ms);
                    promise.then(resolve, reject);
                }).then((response) => {
                    if (response.ok && response.status === 200) {
                        if (response[config.format]) {
                            return response[config.format]();
                        }
                        else {
                            throw new Error(`${response.status} - The response format ${config.format} is not available on current response.`);
                        }
                    }
                    else {
                        throw new Error(`${response.status} - ${response.statusText ||
                            "No message from server."}`);
                    }
                });
            }
            function retry(promise, counter) {
                return new Promise((resolve, reject) => {
                    retryHelper(promise, counter);
                    function retryHelper(promise, counter) {
                        promise()
                            .then(data => {
                            resolve(data);
                        })
                            .catch(err => {
                            if (counter >= 0) {
                                setTimeout(() => {
                                    retryHelper(promise, --counter);
                                }, 500);
                            }
                            else {
                                reject(err);
                            }
                        });
                    }
                });
            }
            return new Promise((resolve, reject) => {
                if (!config.token) {
                    resolve();
                }
                else {
                    retry(() => {
                        return fetch(token.url, {
                            method: "GET"
                        });
                    }, config.retry)
                        .then((response) => response.text())
                        .then(data => {
                        resolve(data);
                    })
                        .catch(() => {
                        reject("Unable to retrieve token");
                    });
                }
            }).then(authToken => {
                let { method, headers, data, timeout, credentials, mode } = config;
                if (url) {
                    if (authToken) {
                        headers[token.header] = authToken;
                    }
                    const body = config.format === "json" ? JSON.stringify(data) : data;
                    let queryParams = Object.keys(config.query)
                        .map(key => {
                        return (encodeURIComponent(key) +
                            "=" +
                            encodeURIComponent(config.query[key]));
                    })
                        .join("&");
                    queryParams = queryParams ? "?" + queryParams : "";
                    return retry(() => {
                        return timeoutHandler(timeout, fetch(url + queryParams, {
                            headers,
                            method,
                            body,
                            mode,
                            credentials
                        }));
                    }, config.retry);
                }
            });
        };
    }
    publish(Fetch(), "Fetch");
})();
